// extracted by mini-css-extract-plugin
module.exports = {"navTitle":"header-nav-item_navTitle__2W5Gv","inactive":"header-nav-item_inactive__3bn5U","active":"header-nav-item_active__21K9O"};